import useDelayedOpening from './useDelayedOpening';
import useCloseOnEscape from './useCloseOnEscape';
import useStackeableModal, { ModalStyles } from './useStackeableModal';
import useModalRoute from './useModalRoute';

type UseModalProps = {
	name: string;
	onClose?: () => void;
	stackOrder?: number;
	defaultStyles?: ModalStyles;
	preventEscEventBubble?: boolean;
};

const useModal = ( {
	name, onClose, stackOrder = 1, defaultStyles = {}, preventEscEventBubble = true
}: UseModalProps ) => {
	const opened = useDelayedOpening();
	const { submodalsStackOrder, modalStyles } = useStackeableModal( { stackOrder, defaultStyles } );

	useCloseOnEscape( { onClose, preventDefault: preventEscEventBubble } );
	useModalRoute( { name } );

	return { opened, stackOrder, submodalsStackOrder, modalStyles };
};

export default useModal;
